module.exports = __webpack_public_path__ + "static/media/recommends_01.f4893166.png";